import {Download, Info} from 'lucide-react'
import React, {FC, useId} from 'react'
import {OverlayTrigger, Tooltip} from 'react-bootstrap'
import {useIntl} from 'react-intl'

interface Props {
  onDownload: () => void
  /** The template is being built: a spinner replaces the icon and the link is disabled. */
  busy?: boolean
  /** The link's own class, so it matches the card it sits in (`step4-te-template-link`, `ta-link`). */
  className: string
}

/**
 * "Download Sample Excel Template (Optional)" with an (i) beside it, the same on Add Teachers and
 * Teacher Allocation (12 Oct review, point 4). The tooltip says the template is optional and any
 * supported file works; it opens on hover, on keyboard focus and on a tap (touch screens). Clicks
 * never reach a dropzone around it, which would open the file picker.
 */
const TemplateDownloadLink: FC<Props> = ({onDownload, busy = false, className}) => {
  const intl = useIntl()
  const tooltipId = useId()
  const stop = (e: React.SyntheticEvent) => e.stopPropagation()
  return (
    <span className='onboarding-template-download' onClick={stop} onKeyDown={stop}>
      <button type='button' className={className} onClick={onDownload} disabled={busy}>
        {busy ? (
          <span className='spinner-border spinner-border-sm' role='status' aria-hidden='true' />
        ) : (
          <Download size={14} aria-hidden />
        )}
        {intl.formatMessage({id: 'ONBOARDING_WIZARD.STEP4_MANUAL.UPLOAD.TEMPLATE_OPTIONAL'})}
      </button>
      <OverlayTrigger
        placement='top'
        trigger={['hover', 'focus', 'click']}
        rootClose
        overlay={
          <Tooltip id={tooltipId} className='ta-tooltip'>
            {intl.formatMessage({id: 'ONBOARDING_WIZARD.STEP4_MANUAL.UPLOAD.TEMPLATE_TOOLTIP'})}
          </Tooltip>
        }
      >
        <button
          type='button'
          className='onboarding-template-download__info'
          aria-label={intl.formatMessage({
            id: 'ONBOARDING_WIZARD.STEP4_MANUAL.UPLOAD.TEMPLATE_INFO_LABEL',
          })}
        >
          <Info size={15} aria-hidden />
        </button>
      </OverlayTrigger>
    </span>
  )
}

export default TemplateDownloadLink
